export const chartLine = [
  '32 32',
  `
<path fill="none" stroke-linejoin="round" stroke-linecap="round" stroke-miterlimit="4" stroke-width="1.92" stroke="#000" d="M30.2 27.833h-28.4v-23.667"></path>
<path fill="none" stroke-linejoin="round" stroke-linecap="round" stroke-miterlimit="4" stroke-width="1.92" stroke="#000" d="M30.2 11.267l-9.467 8.283-9.467-7.1-9.467 8.283"></path>
`,
]
